export default __webpack_public_path__ + "static/media/edit1.475e1877.svg";